import styled, { css } from 'styled-components';
import { theme } from '../../../../styles/theme';

export const Container = styled.div<{ $disabled?: boolean }>`
  display: flex;
  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      opacity: 0.8;
    `}
`;

export const StartDateShortcutContainer = styled.div`
  flex: 0 0 auto;
  width: 90px;
  padding-top: 8px;
`;

export const Footer = styled.div`
  border-top: 1px solid ${theme.colors.border};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  column-gap: 16px;
`;

export const Space = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 16px;
`;
